import { gql } from '@apollo/client';
import { MediaQueries } from '@minecraft.shared-queries';

export const ATTACH_MEDIA_TO_ARTIST = gql`
  mutation attachMediaToArtist($artistId: Int, $mediaId: Int!) {
    attachMediaToArtist(artistId: $artistId, mediaId: $mediaId) {
      __typename
      ...BaseMediaWithThumbnail
    }
  }
  ${MediaQueries.baseMediaWithThumbnailFragment}
`;

export const GET_ARTIST_MEDIA_BY_TYPE = gql`
  query getMediaByArtist($artistId: Float, $mediaTypeCode: String!) {
    getMediaByArtist(artistId: $artistId, mediaTypeCode: $mediaTypeCode) {
      __typename
      id
      mediaId
      media {
        __typename
        ...BaseMediaWithThumbnail
      }
    }
  }
  ${MediaQueries.baseMediaWithThumbnailFragment}
`;
